import { render, staticRenderFns } from "./CollectorNew.vue?vue&type=template&id=b7ac02d2&"
import script from "./CollectorNew.vue?vue&type=script&lang=js&"
export * from "./CollectorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports